import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useState } from 'react';
import { useSession } from '@/shared/lib/auth-client';
import { sessionExpiredStore } from '@/shared/lib/session-expired-store';
import { Button } from '@/shared/ui/button';
import { Input } from '@/shared/ui/input';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/shared/ui/card';

export const Route = createFileRoute('/_authenticated/')({
  component: AuthenticatedIndexPage,
});

function AuthenticatedIndexPage() {
  const { data: session } = useSession();

  if (session?.user.role === 'admin') {
    return <AdminMallSelector />;
  }

  // Cafe24 앱은 항상 /$mallId 경로로 진입하므로 여기 도달하면 잘못된 접근
  sessionExpiredStore.setExpired();
  return null;
}

function AdminMallSelector() {
  const [mallId, setMallId] = useState('');
  const navigate = useNavigate();

  const handleNavigate = () => {
    const trimmed = mallId.trim();
    if (!trimmed) return;
    navigate({ to: '/$mallId', params: { mallId: trimmed } });
  };

  return (
    <div className="flex min-h-[80vh] items-center justify-center">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="text-xl">Admin Mall Viewer</CardTitle>
          <CardDescription>조회할 Mall ID를 입력하세요</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Input
            placeholder="mall-id"
            value={mallId}
            onChange={(e) => setMallId(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleNavigate()}
          />
          <Button className="w-full" onClick={handleNavigate} disabled={!mallId.trim()}>
            이동
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
